import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import EditCorpContract from "./editCorpContract";
import { locationPinCode,shipTolocationPinCode } from "services/redux/sales/corporate/locations/action";
import { postSalesEditCorporateLead, getContractRevenue, getContractService } from "services/redux/sales/postSales/action";
import { clientBillingAddress } from "services/redux/sales/corporate/client/action";
import {
  contractCorporate,
  getMateriaById,
  getBrandById,
  getTagById,
} from "services/redux/sales/postSales/contractCorporate/action";
import {
  documentUploadUrl,
  imageUploadUrl,
  videoUploadUrl,
} from "services/redux/fileUpload/action";
import { supplyNameFun } from "services/redux/sales/corporate/categoryDetails/action";

const mapStateToProps = (state) => ({
//   postCorData: state.coporatePostLeadReducer.postCorData,
  contractCorpData: state.contractCorporateReducer.contractCorpData,
  pincodeData: state.locationReducer.pincodeData,
  getMaterial: state.coporatePostLeadReducer.getMaterial,
  getBrand: state.coporatePostLeadReducer.getBrand,
  getTag: state.coporatePostLeadReducer.getTagById,
  documentUrlData: state.fileUploadReducer.documentUrlData,
  splNameData: state.categoryDetlReducer.splNameData,
  shipToPincodeData:  state.locationReducer.shipToPincodeData,
  clientBillingPocData: state.clientReducer.billingAddressPoc,
  contractRevenueDetails: state.postSalesReducer.contractRevenueDetails,
  contractCatService: state.postSalesReducer.contractCatService,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      contractCorporate,
      locationPinCode,
      postSalesEditCorporateLead,
      getMateriaById,
      getBrandById,
      getTagById,
      documentUploadUrl,
      imageUploadUrl,
      videoUploadUrl,
      supplyNameFun,
      shipTolocationPinCode,
      clientBillingAddress,
      getContractRevenue,
      getContractService
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(EditCorpContract);
